import type { Action } from '@ngrx/store';
import type { LoggedUserState } from 'app/store/login/logged-user/logged-user.state';
import { createReducer, on } from '@ngrx/store';
import * as LoginActions from 'app/store/login/logged-user/logged-user.actions';
import { initialLoggedUserState } from 'app/store/login/logged-user/logged-user.state';

const reducer = createReducer(
  initialLoggedUserState,
  on(LoginActions.logInSuccess, (state, { token }) => ({ ...state, token })),
  on(LoginActions.resetLoggedUser, state => ({ ...state, token: null, isRefreshing: false })),
  on(LoginActions.markRefreshing, (state, { value }) => ({ ...state, isRefreshing: value })),
);

export function loggedUserReducer(state: LoggedUserState | undefined, action: Action): LoggedUserState {
  return reducer(state, action);
}
